<div class="mt-2">
  <app-base-card [cardTitle]="'HOME.BALANCE' | transloco" [cardIcon]="'information-circle-outline'" (click)="toggleModal()">
    <div *ngIf="!busy; else loadingState">
      <ng-container *ngIf="userWalletCurrentValue; else emptyState">
        <h3 class="!text-5xl bold">{{ userWalletCurrentValue.attributes.totalEuroValue | currency : 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</h3>
        <p class="text-gray-400 !mt-2">
          {{ 'HOME.LAST_UPDATE' | transloco }} {{ userWalletCurrentValue.attributes.date | date:'dd.MM.yyyy' }} 
        </p>
      </ng-container>
    </div>
    <ng-template #loadingState>
      <ion-skeleton-text class="!text-5xl !mt-2" [animated]="true"></ion-skeleton-text>
      <ion-skeleton-text class="!mt-2" [animated]="true"></ion-skeleton-text>
    </ng-template>
    <ng-template #emptyState>
        <ion-label color="dark">{{ 'WALLET.NO_PERF' | transloco }}</ion-label> 
    </ng-template>
  </app-base-card>
</div>

<app-sheet-modal
  [(isModalOpen)]="isModalVisible"
  [title]="'WALLET.INFORMATION.TITLE' | transloco"
>
  <p *ngIf="userWalletCurrentValue" class="mt-4 ml-4">{{ 'HOME.ACCOUNT_NUMBER' | transloco }} : {{ accountNumber }}</p>
  <p *ngIf="userWalletCurrentValue" class="ml-4">{{ 'HOME.BALANCE' | transloco }} : {{ userWalletCurrentValue.attributes.totalEuroValue | currency : 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</p>
  <p *ngIf="userWalletCurrentValue" class="ml-4">{{ 'HOME.LAST_UPDATE' | transloco }} {{ userWalletCurrentValue.attributes.date | date:'dd.MM.yyyy' }}</p>
  <p class="text-gray-500 m-4 whitespace-pre-wrap">{{ 'WALLET.INFORMATION.TEXT' | transloco }}</p>
</app-sheet-modal>